<template>
  <load-form-handler
    :promise="getTabPromise"
    v-model="resource"
    placeholder
    @error="onRequestError"
    @load-end="onLoadEnd">

    <h1 class="text-center">Gostamos de utilizar fotos dos nossos alunos e sua autorização é essencial para nossas campanhas.</h1>
    <v-divider class="my-4 divider-accent"/>

    <v-form @submit.prevent="handleUpdateTab" id="tab-form">
      <v-card>
        <v-flex pa-4>
          <h2 class="mb-2">A Maple Bear Canadian School solicita a sua autorização para a participação do(a) aluno(a) nas filmagens e fotos que serão utilizadas das seguintes formas:</h2>
          <h3 class="mb-4 text-secondary">Maple Bear Canadian School asks permission for your childs participation in videos and photos that can be used as:</h3>

          <h3>1 - FOTOS E VÍDEOS QUE SERÃO ENVIADAS AOS PAIS (SALA OU DA ESCOLA) ATRAVÉS DA AGENDA ELETRÔNICA, E-MAIL, CD, DVD OU OUTROS MEIOS / PHOTOS AND VIDEOS THAT WILL BE SENT TO PARENTS (ALL SCHOOL OR CLASSROOMS) BY ELETRONIC AGENDA, E-MAIL, CD, DVD OR OTHER MEANS OF COMMUNICATION.</h3>
          <v-radio-group v-model="resource.allow_to_sent_to_fathers" row>
            <v-radio label="EU AUTORIZO / I ALLOW" :value="true"></v-radio>
            <v-radio label="EU NÃO AUTORIZO / I DO NOT ALLOW" :value="false"></v-radio>
          </v-radio-group>

          <h3>2 - FOTOS E VÍDEOS QUE SERÃO USADOS EM NOSSO SITE OU EM NOSSA PÁGINA DO FACEBOOK; / PHOTOS AND VIDEOS THAT WILL BE POSTED ON OUR WEBSITE OR FACEBOOK PAGE</h3>
          <v-radio-group v-model="resource.allow_site_or_facebook" row>
            <v-radio label="EU AUTORIZO / I ALLOW" :value="true"></v-radio>
            <v-radio label="EU NÃO AUTORIZO / I DO NOT ALLOW" :value="false"></v-radio>
          </v-radio-group>

          <h3>3 - FOTOS E VÍDEOS PARA FINS DE MARKETING; / PHOTOS AND VIDEOS FOR MARKETING PURPOSES</h3>
          <v-radio-group v-model="resource.allow_marketing" row>
            <v-radio label="EU AUTORIZO / I ALLOW" :value="true"></v-radio>
            <v-radio label="EU NÃO AUTORIZO / I DO NOT ALLOW" :value="false"></v-radio>
          </v-radio-group>
        </v-flex>
      </v-card>

    </v-form>

    <alert-modal
      :visibility="declarationModalVisibility"
      title="Confirmação de dados"
      :message="declarationMessage"
      confirmAction="OK"
      cancelAction="CANCELAR"
      @confirm="onDeclarationModal"
      @cancel="closeDeclarationModal" />

  </load-form-handler>
</template>

<script>
import * as api from '@/api'
import LoadFormHandler from '@/components/LoadFormHandler'
import { formTabs, message, declaration, tab } from '@/mixins'
import AlertModal from '@/components/AlertModal'

/**
 * @group Form
 * Componente de form para autorização de uso de imagem estudante
 */
export default {
  name: 'FormImageRight',

  components: {
    LoadFormHandler,
    AlertModal
  },

  data: () => ({
    resource: {},
    isFormLoading: true,
    emptyRule: [v => !!v || 'Campo obrigatório/Field is required']
  }),

  mixins: [formTabs, message, declaration, tab],

  methods: {
    getTabPromise () {
      return api.forms.imageRights.get(this.currentStudentId)
    },

    handleUpdateTab () {
      this.openDeclarationModal()
    },

    onDeclarationModal () {
      api.forms.imageRights.update(this.currentStudentId, this.resource)
        .then(({ data }) => {
          this.resource = data
          this.showMessageByType(this.messageTypes.MODIFIED)
        }).catch(this.handleErrorMessage)
        .finally(this.closeDeclarationModal)
    }
  }
}
</script>
